// 今日爆料 · 首页静态种子数据（仅展示用，不接接口）

export const siteName = '今日爆料';

export const navLinks = [
  { label: '最新实锤', hash: '#zui-xin' },
  { label: '证据品类', hash: '#lei-xing' },
  { label: '话题墙', hash: '#hua-ti' },
  { label: '深度档案', hash: '#shen-du' },
  { label: '提交线索', hash: '#ru-kou' },
];

export const heroStats = [
  { value: '328', label: '累计核实档案' },
  { value: '1,204', label: '留档证据文件' },
  { value: '46h', label: '已核对录音时长' },
  { value: '97%', label: '出稿双源复核' },
];

export interface EvidenceItem {
  kind: string;
  kindIcon: string;
  kindTone: 'primary' | 'accent' | 'secondary';
  title: string;
  excerpt: string;
  files: number;
  status: string;
  updated: string;
  cover: string;
  coverAlt: string;
}

export const latestEvidence: EvidenceItem[] = [
  {
    kind: '文件曝光',
    kindIcon: 'ri-file-text-line',
    kindTone: 'primary',
    title: '一份被下线的采购公告，为何在归档里留了七个版本？',
    excerpt:
      '同一标的先后七次变动参数，最新一版恰好只剩一家企业达标。逐版比对后，关键条款的删除时间线与中标时间重合。',
    files: 14,
    status: '已完成三方交叉核验',
    updated: '2026-09-05 更新',
    cover:
      'https://readdy.ai/api/search-image?query=close%20up%20of%20stacked%20printed%20report%20pages%20with%20black%20redaction%20bars%20and%20highlighted%20margin%20lines%20on%20a%20light%20wooden%20desk%20warm%20soft%20natural%20light%20editorial%20documentary%20photography%20cream%20and%20amber%20tones%20high%20detail%20realistic%20paper%20texture%20no%20people&width=1200&height=900&seq=latest-evidence-01&orientation=landscape',
    coverAlt: '被标记曝光的文件证据打印件',
  },
  {
    kind: '合同截图',
    kindIcon: 'ri-file-list-3-line',
    kindTone: 'accent',
    title: '签字页与骑缝章对不上号的一份合作补充协议',
    excerpt:
      '扫描件页码完整、章位清晰，但放大到 300% 后，落款处文字的行距与全篇不一致——像是从另一份合同裁贴而来。',
    files: 9,
    status: '原文件已留档保存',
    updated: '2026-09-04 更新',
    cover:
      'https://readdy.ai/api/search-image?query=printed%20contract%20pages%20with%20a%20red%20company%20stamp%20and%20ink%20signature%20lying%20on%20a%20desk%20beside%20a%20pen%20and%20paperclip%20warm%20soft%20evening%20light%20editorial%20documentary%20photography%20beige%20and%20cream%20background%20high%20detail%20no%20people&width=1200&height=900&seq=latest-evidence-02&orientation=landscape',
    coverAlt: '带有签章待核对的合同页面',
  },
  {
    kind: '转账记录',
    kindIcon: 'ri-bank-line',
    kindTone: 'secondary',
    title: '同一笔金额、两种备注，银行流水替谁说了话？',
    excerpt:
      '对外公布的备注为“服务费”，留存的回单却写着另一处用途。两张回单间隔仅数分钟，收款账户指向同一关联方。',
    files: 21,
    status: '银行回单原件已核验',
    updated: '2026-09-03 更新',
    cover:
      'https://readdy.ai/api/search-image?query=bank%20transfer%20receipts%20and%20printed%20ledger%20pages%20arranged%20neatly%20on%20a%20desk%20with%20warm%20desk%20light%20editorial%20documentary%20photography%20neutral%20cream%20background%20high%20detail%20no%20people&width=1200&height=900&seq=latest-evidence-03&orientation=landscape',
    coverAlt: '银行转账回单与流水明细打印件',
  },
];

export interface CategoryItem {
  icon: string;
  name: string;
  count: string;
  desc: string;
}

export const categories: CategoryItem[] = [
  {
    icon: 'ri-file-text-line',
    name: '文件曝光',
    count: '86 份',
    desc: '公文、公告、内部文件的逐版留档与删改比对',
  },
  {
    icon: 'ri-mic-line',
    name: '录音证据',
    count: '46 段',
    desc: '现场对话与会议录音，转写稿逐句可回溯',
  },
  {
    icon: 'ri-file-list-3-line',
    name: '合同截图',
    count: '63 组',
    desc: '协议、补充条款与签章页的原图细节放大',
  },
  {
    icon: 'ri-bank-line',
    name: '转账记录',
    count: '118 条',
    desc: '流水回单与资金去向的可视化关联梳理',
  },
  {
    icon: 'ri-mail-send-line',
    name: '邮件往来',
    count: '74 封',
    desc: '沟通邮件的时间线与关键表述的对照归档',
  },
];

export interface TopicGroup {
  group: string;
  topics: { name: string; count: number }[];
}

export const topicGroups: TopicGroup[] = [
  {
    group: '招标采购',
    topics: [
      { name: '围标串标', count: 31 },
      { name: '参数量身定制', count: 19 },
      { name: '评标结果异常', count: 14 },
      { name: '二次报价', count: 9 },
    ],
  },
  {
    group: '资金往来',
    topics: [
      { name: '关联方输血', count: 27 },
      { name: '阴阳合同', count: 18 },
      { name: '代持与空壳', count: 22 },
      { name: '异常对公转账', count: 16 },
    ],
  },
  {
    group: '公共项目',
    topics: [
      { name: '验收走过场', count: 12 },
      { name: '监理形同虚设', count: 8 },
      { name: '名义与实际不符', count: 21 },
      { name: '工期造假', count: 7 },
    ],
  },
  {
    group: '组织人事',
    topics: [
      { name: '任前突击提拔', count: 6 },
      { name: '关系户任职', count: 15 },
      { name: '档案前后矛盾', count: 11 },
      { name: '兼职经商', count: 9 },
    ],
  },
  {
    group: '媒体与公关',
    topics: [
      { name: '删稿与改稿', count: 13 },
      { name: '通稿式回应', count: 10 },
      { name: '清空痕迹', count: 17 },
      { name: '水军舆情', count: 5 },
    ],
  },
];

export interface Principle {
  icon: string;
  title: string;
  desc: string;
}

export const principles: Principle[] = [
  {
    icon: 'ri-fingerprint-line',
    title: '来源可溯',
    desc: '每份材料都登记来源途径与获得方式，隐去涉密个人信息后原文留档，供二次核验。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '多源交叉',
    desc: '单一截图不作数。关键结论至少有两路独立来源对得上，时间、金额、主体逐项对齐。',
  },
  {
    icon: 'ri-file-shield-line',
    title: '原件比对',
    desc: '优先核验原文件而非转述。签章、水印、版式异常会单独标注，绝不替当事人下结论。',
  },
  {
    icon: 'ri-scales-line',
    title: '留白存疑',
    desc: '一时无法证实的细节，明说“待核实”并放到待证区，不在证据不足处做大胆断言。',
  },
];

export interface DossierItem {
  kicker: string;
  kickerIcon: string;
  title: string;
  summary: string;
  date: string;
  minutes: string;
  thumb: string;
  thumbAlt: string;
}

export const dossiers: DossierItem[] = [
  {
    kicker: '合同截图',
    kickerIcon: 'ri-file-list-3-line',
    title: '补充协议的页眉里，藏着一家“没有对手”的公司',
    summary: '把散落的补充协议按页眉标识归拢，一家从未在公开中标名单里出现的公司，反复出现在乙方一栏。',
    date: '2026-09-01',
    minutes: '9 分钟阅读',
    thumb:
      'https://readdy.ai/api/search-image?query=folder%20of%20official%20documents%20with%20a%20red%20stamp%20beside%20a%20magnifying%20glass%20on%20a%20wooden%20desk%20warm%20soft%20light%20editorial%20documentary%20photography%20no%20people&width=900&height=600&seq=dossier-thumb-01&orientation=landscape',
    thumbAlt: '带印章的官方文件与放大镜',
  },
  {
    kicker: '录音证据',
    kickerIcon: 'ri-mic-line',
    title: '一段会议录音里，那句被反复“再议”的安排',
    summary: '四十分钟录音，涉及某项目分配方案的措辞被改了六次。转写稿标出时间轴，供对照原声逐句核对。',
    date: '2026-08-28',
    minutes: '12 分钟阅读',
    thumb:
      'https://readdy.ai/api/search-image?query=portable%20audio%20recorder%20on%20a%20desk%20with%20notebooks%20and%20earphones%20warm%20desk%20light%20editorial%20documentary%20photography%20no%20people&width=900&height=600&seq=dossier-thumb-02&orientation=landscape',
    thumbAlt: '桌面上的录音笔与笔记本',
  },
  {
    kicker: '邮件往来',
    kickerIcon: 'ri-mail-send-line',
    title: '一封深夜发出的邮件，把所有解释提前写好了',
    summary: '邮件时间与事件公开化高度吻合。正文里对结果的预判过于精准，读起来不像沟通，更像“预案”。',
    date: '2026-08-22',
    minutes: '8 分钟阅读',
    thumb:
      'https://readdy.ai/api/search-image?query=printed%20email%20thread%20sheets%20with%20timestamps%20beside%20a%20laptop%20soft%20blur%20warm%20desk%20evening%20light%20editorial%20documentary%20photography%20no%20people&width=900&height=600&seq=dossier-thumb-03&orientation=landscape',
    thumbAlt: '打印的邮件往来记录与电脑',
  },
];

export interface HubCard {
  icon: string;
  title: string;
  desc: string;
  action: string;
}

export const hubCards: HubCard[] = [
  {
    icon: 'ri-upload-cloud-2-line',
    title: '提交线索',
    desc: '有材料但不确定怎么整理？留下线索与原始文件，编辑团队会在隐去敏感信息后协助留档。',
    action: '进入提交入口',
  },
  {
    icon: 'ri-tools-line',
    title: '证据工具箱',
    desc: '取证、比对、水印、时间线整理的常用方法与模板说明，帮你把随手材料变成规范证据包。',
    action: '查看工具箱',
  },
  {
    icon: 'ri-group-2-line',
    title: '取证读者群',
    desc: '与关注同一类议题的读者共享核对进度，多人协作盯同一件事，让证据链更完整。',
    action: '申请加入',
  },
];

export const footerNote =
  '今日爆料为公开信息的整理与留档平台，所展示内容均标注来源与核验状态。我们不对任何个人或单位作出法律定性，具体事实以有权机关的认定为准。涉及人身与商业信息的敏感部分已在留档时做模糊化处理。';